import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrgData } from "./OrgSlice";
import objectToFormData from "../utils/objectToFormData";
import axios from "axios";
import { toast } from "react-toastify";
import { showSavedPopup } from "./PopupsSlice";
import uuidGenerator from "../utils/uuidGenerator";

const apiBaseUrl = process.env.REACT_APP_BASE_URL_API;

export const updatePayoutMethod = createAsyncThunk("org/updatePayoutMethod", async (payoutData, thunkAPI) => {
  const { rejectWithValue, dispatch, getState } = thunkAPI;

  try {
    await axios.post(
      `${apiBaseUrl}/api/v7/commands/update_org_payout_settings`,
      objectToFormData({
        "settings.legal_business_name": payoutData.legalBusinessName,
        "settings.business_type": payoutData.businessType,
        "settings.tax_number": payoutData.taxNumber,
        "settings.business_address": payoutData.businessAddress,
        "settings.business_website_url": payoutData.businessWebsiteUrl,
        "settings.business_contact_email": payoutData.businessContactEmail,
        "settings.business_phone_number": payoutData.businessPhoneNumber,
        "settings.bank_country": payoutData.bankCountry,
        "settings.account_name": payoutData.accountName,
        "settings.account_number": payoutData.accountNumber,
        "settings.bank_name": payoutData.bankName,
        "settings.branch_code": payoutData.branchCode,
        "settings.swift_code": payoutData.swiftCode,
        "settings.full_name": payoutData.fullName,
        "settings.date_of_birth": payoutData.dateOfBirth,
        "settings.email": payoutData.email,
        "settings.phone_number": payoutData.phoneNumber,
        "settings.address": payoutData.address,
        org_id: getState().orgData.orgData.org.orgId,
      })
    );

    dispatch(showSavedPopup());
    return { ...payoutData };
  } catch ({ response }) {
    toast.error(response.data.message || response.statusText);
    return rejectWithValue(response.message);
  }
});

const payoutSlice = createSlice({
  name: "payout",
  initialState: { payoutData: [] },
  reducers: {},
  extraReducers: {
    //get org data
    [getOrgData.fulfilled]: (state, action) => {
      state.payoutData = action.payload.payoutMethod;
      // state.isLoading = false;
    },

    [updatePayoutMethod.fulfilled]: (state, action) => {
      state.payoutData = action.payload;
    },
    // [updatePayoutMethod.pending]: (state) => {},
    // [updatePayoutMethod.rejected]: (state) => {},
  },
});

export default payoutSlice.reducer;
